import {obieApi} from 'lib/obie/url'
import {useOrganization} from 'organization/OrganizationProvider'
import {useEffect, useState} from 'react'
import {useQuery} from 'react-query'
import {useOrganizationObieClient} from './use-organization-obie-client'

interface UseAssistantThreadParams {
  id: number
}

export interface ThreadMessage {
  id: string
  content: string
  type: 'user' | 'assistant'
}

export interface AssistantThread {
  assistant_id: number
  id: number
  messages: ThreadMessage[]
}

export function useAssistantThread(params: UseAssistantThreadParams) {
  const {id} = params
  const {organization} = useOrganization()

  const {client} = useOrganizationObieClient()

  return useQuery({
    queryKey: ['organizations', organization.id, 'assistant_threads', id],
    queryFn: () =>
      client?.get<AssistantThread>(
        obieApi(`/organizations/${organization.id}/assistant_threads/${id}`),
      ),
  })
}

export function useAssistantThreadMessages(params: UseAssistantThreadParams) {
  const [messages, setMessages] = useState<ThreadMessage[]>([])
  const [initialized, setInitialized] = useState(false)

  const {data: thread} = useAssistantThread(params)

  useEffect(() => {
    if (!thread || initialized) {
      return
    }

    setMessages(thread.messages)
    setInitialized(true)
  }, [thread, initialized])

  return [messages, setMessages] as const
}
